import React from 'react'
import Icon from './icon'
import Header from './header'
import { MenuIcon, MenuItem } from './menu'
import { Avatar, Thumb } from './picture'

import './table.css'

const Cell = ({cell, className}) => {
  return (
    <div className={`table-cell ${className}`}>
      {cell}
    </div>
  )
}

const Row = ({ id, index, icon, avatar, thumb, name="Name", cells=[], value, color, onSelect, menu }) => {

  const handleSelect = () => {
    if (onSelect) onSelect(id)
  }

  return (
    <div key={`${id}_${index}`} className={`table-row ${color}`} onClick={handleSelect}>
      <div className="table-index">{index}</div>
      { avatar ? <Avatar avatar={avatar} /> : ''}
      { icon ? <Icon icon={icon} /> : ''}
      { thumb ? <Thumb src={thumb} /> : ''}
      <span className="body2">{name}</span>
      { cells.map( cell => <Cell cell={cell}/> )}
      { value   ? <Cell className="value" cell={value} /> : '' }
      { menu ? <MenuIcon>{menu.items.map(item => (<MenuItem id={id} {...item}/>))}</MenuIcon> : '' }
    </div>
  )
}

/**
 * Table
 */
const Table = ({ index, icon, title, rows = [], children, onSelect }) => {
  return (
    <div className="table-box">
      { title || children ? (<Header icon={ icon ? { icon } : null} title={title} className="table-header">{children}</Header>) : '' }
      <main className="table">
        {rows.map((row, i) => <Row {...row} onSelect={onSelect} index={index ? i : null} />)}
      </main>
    </div>
  )
}

export default Table;



// WEBPACK FOOTER //
// ./src/lib/components/table.js